/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 13/9/2022
 */

// import Vue from "@/setupVue3.js"
// import {generateLink, insertSubstringAtPosition, asBase64} from "@/utils/helpers";
//
// Vue.config.globalProperties.asBase64 = asBase64
// Vue.config.globalProperties.generateLink = generateLink
// Vue.config.globalProperties.insertSubstringAtPosition = insertSubstringAtPosition
import CommonObject from "@shared/CommonObject";

import dataManager from "@/entry/setupDataManager"

import {generateLink, insertSubstringAtPosition, asBase64} from "@/utils/helpers";

CommonObject.dataManager = dataManager
CommonObject.asBase64 = asBase64
CommonObject.generateLink = generateLink
CommonObject.insertSubstringAtPosition = insertSubstringAtPosition



console.log("commonClientServerCode Client: CommonObject = ", CommonObject)

export default CommonObject
